import { Column, Entity, ManyToOne, OneToMany, PrimaryGeneratedColumn } from "typeorm"
import { KamiClient } from "./KamiClient"
import { KamiCameraType } from "../../enumerations"
import { KamiPortRange } from "./KamiPortRange"

@Entity()
export class KamiTarget {
  @PrimaryGeneratedColumn({ name:"id" })
  id?: number;

  @ManyToOne(() => KamiClient, (kamiClient) => kamiClient.targets, { onDelete:'CASCADE' })
  kamiClient?: KamiClient

  @Column()
  type?: KamiCameraType

  @OneToMany(() => KamiPortRange, (portRange) => portRange.owner, { cascade: true })
  portRanges?: KamiPortRange[]

  @Column()
  http_basic_authentication?: boolean

  @Column({nullable:true, default:null})
  http_basic_authentication_username?: string

  @Column({nullable:true, default:null})
  http_basic_authentication_password?: string
}  